var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 8 10",
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2 1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.23745 2.98744c-.68342.68342-1.791455.68342-2.474875 0s-.68342-1.791455 0-2.474875 1.791455-.68342 2.474875 0 .68342 1.791455 0 2.474875z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.5v.5c0 .276.224.5.5.5h7c.276 0 .5-.224.5-.5v-.5c0-1.513-1.976-2.496-4-2.496s-4 .983-4 2.496z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v12h-12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6c0e8c753259ead3034510511d75cd8a.svg";
export { ForwardRef as ReactComponent };